import { render } from "./DeactivatedStaff.vue?vue&type=template&id=993267ec"
import script from "./DeactivatedStaff.vue?vue&type=script&lang=js"
export * from "./DeactivatedStaff.vue?vue&type=script&lang=js"

import "./DeactivatedStaff.vue?vue&type=style&index=0&id=993267ec&lang=css"
import "./DeactivatedStaff.vue?vue&type=style&index=1&id=993267ec&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__